import axios from "axios";
import React from "react";
import ReactPlayer from "react-player";
import { Link, NavLink } from "react-router-dom";
import { baseURL } from "../../Config/Config";
import Footer from "../../Footer/Footer";
import muallif from "../../assets/muallif.jpg";

import Navbar from "../../Navbar/Navbar";
import Mundareja from "../Mundareja/Mundareja";

export default function MediaMaterial() {
  const [posts, setPosts] = React.useState();

  React.useEffect(() => {
    axios.get(`${baseURL}video/video-material-list/`).then((response) => {
      setPosts(response.data.results);
    });
  }, []);
  if (!posts) return null;

  return (
    <div>
      <Navbar />
      <div className="container">
        <div className="text-name">
          <h1>Biznes Asoslari</h1>
        </div>
        <div className="left">
          <Link to="/" className="bosh">
            Bosh sahifa
          </Link>
          <Link to="/boshlangich-talim" className="left-material bosh">
            Boshlang’ich kasbiy ta’lim
          </Link>
          <Link>Biznes Asoslari</Link>
        </div>
        <div className="text-box">
          <div className="text-left">
            <Mundareja />
          </div>
          <div className="text-right">
            <div className="materiallar">
              <div className="material-btn">
                <NavLink to="/textpage">Maruza matn</NavLink>
              </div>
              <div className="material-btn">
                <NavLink>Media materiallar</NavLink>
              </div>
              <div className="material-btn">
                <NavLink to="/korgazma">Ko‘rgazma materiallari </NavLink>
              </div>
              <div className="material-btn">
                <NavLink>Taqdimotlar</NavLink>
              </div>
            </div>
            <div className="fan-videos">
              {posts.map((post, index) => {
                return (
                  <div className="card-video">
                    <ReactPlayer
                      className="video bigvideo"
                      url={post.video_link}
                    />
                    <div className="fan-video-title">
                      <h4>{post.title}</h4>
                      <p>{post.sub_content}</p>
                    </div>
                    <div className="name">
                      <div className="muallif-img">
                        <img src={muallif} alt="some-img" />
                      </div>
                      <span> {post.author}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
